import { forwardRef, useState } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, Input, InputAdornment } from 'components/ui';
import AuthFieldShell from 'pages/Auth/components/AuthFieldShell';
import {
  AUTH_PASSWORD_FIELD_HIDE_PASSWORD_LABEL,
  AUTH_PASSWORD_FIELD_SHOW_PASSWORD_LABEL,
} from './AuthPasswordField.constants';
import { AuthPasswordFieldProps } from './AuthPasswordField.props';

const AuthPasswordField = forwardRef<HTMLInputElement, AuthPasswordFieldProps>(
  ({ disabled, error, helperText, hideLabel = false, id, label, placeholder, sx, ...props }, ref) => {
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const visibilityLabel = isPasswordVisible
      ? AUTH_PASSWORD_FIELD_HIDE_PASSWORD_LABEL
      : AUTH_PASSWORD_FIELD_SHOW_PASSWORD_LABEL;

    return (
      <AuthFieldShell error={error} helperText={helperText} hideLabel={hideLabel} id={id} label={label}>
        {resolvedHelperText => (
          <Input
            {...props}
            disabled={disabled}
            error={error}
            helperText={resolvedHelperText}
            hiddenLabel
            id={id}
            inputRef={ref}
            placeholder={placeholder}
            sx={sx}
            type={isPasswordVisible ? 'text' : 'password'}
            variant="outlined"
            visualVariant="compactOutlined"
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end" sx={{ mr: '5px' }}>
                    <IconButton
                      aria-label={visibilityLabel}
                      onClick={() => setIsPasswordVisible(currentValue => !currentValue)}
                      size="small"
                      type="button"
                    >
                      {isPasswordVisible ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
          />
        )}
      </AuthFieldShell>
    );
  }
);

AuthPasswordField.displayName = 'AuthPasswordField';

export default AuthPasswordField;
